import React from "react";
import styled from "styled-components";
import BaseGrid from "Components/Fragment/BaseGrid";
import { Button } from "Components/Base/Inputs/Button";

const StyledButton = styled(Button)`
  min-height: 54px !important;
  height: auto !important;
  justify-content: flex-start !important;
`;

const StyledTextWrapper = styled.div`
  text-align: left;
  padding: 5px;
`;

const StyledHeading = styled.div`
  color: white !important;
  font-size 14px !important: 
  font-weight: bold;
  text-transform: uppercase;
`;

const StyledSubheading = styled.div`
  color: white !important;
  font-size 14px !important: 
`;

const CircleIconStyle = {
  backgroundColor: "white",
  borderRadius: "100%",
  fontSize: "30px",
  padding: "4px",
};

/**
 * OptionButtons component renders a set of buttons with customizable options.
 *
 * @component
 * @param {Array<Object>} props.options - An array of option objects to be rendered as buttons.
 * @param {string} props.options[].title - The title of the option.
 * @param {string} [props.options[].description] - The description or subheading of the option (optional).
 * @param {React.ReactNode} props.options[].icon - The React node representing the icon for the option.
 * @param {Function} props.options[].onClick - The click handler function for the option button.
 * @returns {React.ReactNode} Returns a BaseGrid component containing the rendered option buttons.
 */

const OptionButtons = ({ options, addCircleIconStyle }) => {
  return (
    <BaseGrid>
      {options.filter(Boolean).map((option, index) => {
        return (
          <StyledButton
            fullWidth
            key={index}
            startIcon={
              addCircleIconStyle
                ? React.cloneElement(option.icon, {
                    style: CircleIconStyle,
                    color: "primary",
                  })
                : option.icon
            }
            onClick={option.onClick}
            label={
              option.description ? (
                <StyledTextWrapper>
                  <StyledHeading>{option.title}</StyledHeading>
                  <StyledSubheading>{option.description}</StyledSubheading>
                </StyledTextWrapper>
              ) : (
                option.title
              )
            }
          />
        );
      })}
    </BaseGrid>
  );
};

export default OptionButtons;
